<template>
  <div class="home">
    <!-- 抽奖界面 -->
    <div class="wrap">
      <transition name="flip-vert-down" appear mode="out-in">
        <div v-if="!showResult" class="wrap-anim" key="draw">
          <div class="container">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="blockTit">
              抽奖界面
            </div>
            <div class="seats">
              <div v-for="(item, idx) in display" :key="idx" class="seat-item">
                <div v-if="item">
                  <div>
                    <span>{{ item.areaType }}</span>
                    <span class="pl_20">{{ item.block }}</span>
                  </div>
                  <div>{{ item.rowLabel }}排 {{ item.seatLabel }}座</div>
                </div>
              </div>
            </div>
          </div>
          <div class="controls">
            <button class="btn btn--start btn--continue" @click="startRolling"
              :disabled="rolling || remaining.length === 0">开始滚动</button>
            <button class="btn btn--stop" @click="stopRolling" :disabled="!rolling">停止滚动</button>
            <!-- <button class="btn btn--start" @click="continueDraw" :disabled="rolling || remaining.length === 0">继续抽奖</button> -->
            <!-- <div class="info">
              <span>剩余可抽：{{ remaining.length }}</span>
              <span>已中奖：{{ winners.length }}</span>
            </div> -->
          </div>
        </div>
      </transition>
    </div>

    <!-- 中奖结果弹窗 -->
    <div v-if="showResult" class="result-mask" @click.self="closeResult">
      <transition name="flip-vert" appear mode="out-in">
        <div>
          <div class="result-modal">
            <!--左上边框-->
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
            <!--右上边框-->
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
            <!--左下边框-->
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
            <!--右下边框-->
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="blockTit">
              中奖结果
            </div>
            <div class="result-body">
              <div v-if="lastWinners.length === 0" class="result-empty">暂无数据</div>
              <div v-else class="result-list">
                <div v-for="w in lastWinners" :key="w.id" class="result-item">
                  <div>
                    <div class="result-left">{{ w.areaType }}<span class="pl_20">{{ w.block }}</span></div>
                    <div class="result-right">{{ w.rowLabel }}排 {{ w.seatLabel }}座</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="result-footer">
            <button class="btn btn--continue" @click="closeResult">我知道了</button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { seatsData } from '@/utils/seats.js'
import { exportWinnersExcel } from '@/utils/exportExcel.js'


export default {
  name: "HomeView",
  data() {
    return {
      seatsData,
      remaining: [],
      winners: [],
      display: [],
      rolling: false,
      intervalId: null,
      showResult: false,
      lastWinners: [],
    };
  },
  mounted() {
    // restore winners from localStorage
    const savedIds = JSON.parse(localStorage.getItem('lottery_winner_ids') || '[]');
    const winnerIdSet = new Set(savedIds);
    this.winners = this.seatsData.filter((x) => winnerIdSet.has(x.id));
    this.remaining = this.seatsData.filter((x) => !winnerIdSet.has(x.id));
    this.display = this.pickDisplay(this.remaining, 10);
    console.log('seats loaded:', this.seatsData.length, 'restored winners:', this.winners.length);
  },
  methods: {
    pickDisplay(source, n) {
      if (!source || source.length === 0) return [];
      const len = Math.min(n, source.length);
      const result = [];
      const used = new Set();
      while (result.length < len) {
        const idx = Math.floor(Math.random() * source.length);
        if (used.has(idx)) continue;
        used.add(idx);
        result.push(source[idx]);
      }
      // pad to fixed length to keep DOM node count and keys stable
      while (result.length < n) {
        result.push(null);
      }
      return result;
    },
    startRolling() {
      if (this.rolling || this.remaining.length === 0) return;
      this.rolling = true;
      this.intervalId = setInterval(() => {
        this.display = this.pickDisplay(this.remaining, 10);
      }, 80);
    },
    stopRolling() {
      if (!this.rolling) return;
      this.rolling = false;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      const finalWinners = this.display.filter(Boolean);
      if (finalWinners && finalWinners.length) {
        const winnerIds = new Set(finalWinners.map((w) => w.id));
        this.winners = this.winners.concat(finalWinners);
        this.remaining = this.remaining.filter((x) => !winnerIds.has(x.id));
        // persist winner ids to localStorage
        localStorage.setItem('lottery_winner_ids', JSON.stringify(this.winners.map((w) => w.id)));
        // show result modal for this round
        this.lastWinners = finalWinners;
        this.showResult = true;
      }
    },
    exportExcel() {
      const ts = new Date().toISOString().slice(0, 19).replace(/T|:/g, '-');
      const filename = `中奖结果_${ts}.xlsx`;
      exportWinnersExcel(this.lastWinners, filename, { title: '中奖结果', time: new Date().toLocaleString() });
    },
    closeResult() {
      this.showResult = false;
      this.exportExcel();
    },
    continueDraw() {
      if (this.rolling || this.remaining.length === 0) return;
      this.display = this.pickDisplay(this.remaining, 10);
      this.startRolling();
    },
  },
};
</script>
<style scoped>
.pl_20 {
  padding-left: 10px;
}

.t_line_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
}

.t_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  top: -3px;
}

.l_t_line {
  width: 5px;
  height: 24px;
  left: -3px;
  top: -3px;
}

.t_r_line {
  height: 5px;
  width: 26px;
  right: -3px;
  top: -3px;
}

.t_line_box i {
  background-color: #FFD700;
  box-shadow: 0px 0px 10px #FFD700;
  position: absolute;
}

.r_t_line {
  width: 5px;
  height: 24px;
  right: -3px;
  top: -3px;
}

.l_b_line {
  width: 5px;
  height: 24px;
  left: -3px;
  bottom: -3px;
}

.b_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  bottom: -3px;
}

.r_b_line {
  width: 5px;
  height: 24px;
  right: -3px;
  bottom: -3px;
}

.b_r_line {
  height: 5px;
  width: 26px;
  right: -3px;
  bottom: -3px;
}

.home {
  width: 100%;
  min-height: 100vh;
  background-image: url("@/assets/bg.jpeg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.wrap {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
}

.wrap-anim {
  backface-visibility: hidden;
  transform-origin: bottom center;
  will-change: transform, opacity;
}

.container {
  width: 1280px;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.5);
  padding:0 40px 40px 40px;
  border: 1px solid #FFD700;
  box-shadow: 0px 0px 6px #FFD700;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.35), 0 0 6px rgba(255, 215, 0, 0.65) inset;
}

.controls {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  position: relative;
  justify-content: center;
  z-index: 11;
  margin: 0 auto;
  margin-top: 20px;
}

.btn {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: none;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.05) inset;
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease, opacity 0.2s ease;
  will-change: transform, filter;
  font-size: 18px;
  font-weight: bold;
}

.btn:disabled {
  background: #a9a9a9;
  cursor: not-allowed;
  opacity: 0.6;
  box-shadow: none;
}

/* Start: emerald glow */
.btn--start {
  background: radial-gradient(120px 120px at 30% 30%, rgba(255, 255, 255, 0.2), transparent 50%),
    linear-gradient(135deg, #2ecc71, #27ae60);
  box-shadow: 0 0 12px rgba(46, 204, 113, 0.6), 0 0 24px rgba(46, 204, 113, 0.35);
}

.btn--start:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 0 14px rgba(46, 204, 113, 0.75), 0 0 28px rgba(46, 204, 113, 0.45);
}

.btn--start:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
  filter: brightness(0.95);
}

/* Stop: danger glow */
.btn--stop {
  background: radial-gradient(120px 120px at 30% 30%, rgba(255, 255, 255, 0.18), transparent 50%),
    linear-gradient(135deg, #ff4d4f, #d9363e);
  box-shadow: 0 0 12px rgba(255, 77, 79, 0.6), 0 0 24px rgba(255, 77, 79, 0.35);
}

.btn--stop:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 0 14px rgba(255, 77, 79, 0.75), 0 0 28px rgba(255, 77, 79, 0.45);
}

.btn--stop:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
  filter: brightness(0.95);
}

/* Continue: gold to match theme */
.btn--continue {
  background: radial-gradient(120px 120px at 30% 30%, rgba(255, 255, 255, 0.22), transparent 55%),
    linear-gradient(135deg, #ffd700, #ffb700);
  color: #202020;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 12px rgba(255, 215, 0, 0.65), 0 0 24px rgba(255, 215, 0, 0.35);
}

.btn--continue:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 0 14px rgba(255, 215, 0, 0.8), 0 0 32px rgba(255, 215, 0, 0.45);
}

.btn--continue:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
  filter: brightness(0.95);
}

.info {
  margin-left: auto;
  display: flex;
  gap: 16px;
  color: #fff;
}

.seats {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 60px;
  margin-top: 20px;
}

.seat-item {
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 8px;
  font-size: 24px;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  position: relative;
  overflow: visible;
  z-index: 1;
}

/* rotating tech ring */
.seat-item::before {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  /* brighter head -> fading tail with decreasing alpha for trailing arc */
  /* three separated arcs with fading tails: 0°, 120°, 240° */
  background:
    conic-gradient(from 0deg,
      /* gap before arc 1 */
      rgba(255, 215, 0, 0) 0 10%,
      /* arc 1 tail -> head -> tail */
      rgba(255, 215, 0, 0.18) 10% 12%,
      rgba(255, 215, 0, 0.32) 12% 14%,
      rgba(255, 215, 0, 0.55) 14% 16%,
      rgba(255, 215, 0, 0.75) 16% 17.5%,
      rgba(255, 215, 0, 1) 17.5% 18.5%,
      rgba(255, 215, 0, 0.75) 18.5% 20%,
      rgba(255, 215, 0, 0.55) 20% 21.5%,
      rgba(255, 215, 0, 0.32) 21.5% 23%,
      rgba(255, 215, 0, 0.18) 23% 25%,
      /* gap between arc 1 and 2 */
      rgba(255, 215, 0, 0) 25% 42%,
      /* arc 2 around ~120° */
      rgba(255, 215, 0, 0.18) 42% 44%,
      rgba(255, 215, 0, 0.32) 44% 46%,
      rgba(255, 215, 0, 0.55) 46% 48%,
      rgba(255, 215, 0, 0.75) 48% 49.5%,
      rgba(255, 215, 0, 1) 49.5% 50.5%,
      rgba(255, 215, 0, 0.75) 50.5% 52%,
      rgba(255, 215, 0, 0.55) 52% 53.5%,
      rgba(255, 215, 0, 0.32) 53.5% 55%,
      rgba(255, 215, 0, 0.18) 55% 57%,
      /* gap between arc 2 and 3 */
      rgba(255, 215, 0, 0) 57% 74%,
      /* arc 3 around ~240° */
      rgba(255, 215, 0, 0.18) 74% 76%,
      rgba(255, 215, 0, 0.32) 76% 78%,
      rgba(255, 215, 0, 0.55) 78% 80%,
      rgba(255, 215, 0, 0.75) 80% 81.5%,
      rgba(255, 215, 0, 1) 81.5% 82.5%,
      rgba(255, 215, 0, 0.75) 82.5% 84%,
      rgba(255, 215, 0, 0.55) 84% 85.5%,
      rgba(255, 215, 0, 0.32) 85.5% 87%,
      rgba(255, 215, 0, 0.18) 87% 89%,
      /* final gap */
      rgba(255, 215, 0, 0) 89% 100%);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
  /* subtle blur helps the tail look thinner visually */
  filter: drop-shadow(0 0 8px #2C58A6) drop-shadow(0 0 16px rgba(44, 88, 166, 0.6)) blur(0.6px);
  animation: spin 2s linear infinite;
  z-index: -1;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* result modal */
.result-mask {
  position: fixed;
  inset: 0;
  /* background: rgba(0, 0, 0, 0.6); */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: mask-fade-in 280ms ease;
  perspective: 1000px;
}

@keyframes mask-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.result-modal {
  width: 1280px;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.5);
  padding: 0px 40px 40px 40px;
  border: 1px solid #FFD700;
  box-shadow: 0px 0px 6px #FFD700;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.35), 0 0 6px rgba(255, 215, 0, 0.65) inset;
}

.blockTit {
  color: #FFD700;
  font-weight: 700;
  font-size: 36px;
  text-align: center;
  margin-top: 20px;
}

.result-close {
  appearance: none;
  border: none;
  background: transparent;
  color: #FFD700;
  font-size: 24px;
  cursor: pointer;
}

.result-body {
  margin-top: 20px;
}

.result-empty {
  color: #ddd;
  text-align: center;
  padding: 40px 0;
}

.result-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 60px;
}

.result-item {
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 8px;
  font-size: 24px;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  position: relative;
  overflow: visible;
  z-index: 1;
}

.result-item:last-child {
  border-bottom: none;
}

.result-left {
  color: #FFD700;
}

.result-right {
  color: #fff;
}

.result-footer {
  padding: 12px 16px 16px 16px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

/* flip vertical transition */
.flip-vert-enter-active,
.flip-vert-leave-active {
  transition: transform 500ms cubic-bezier(0.22, 1, 0.36, 1), opacity 380ms ease;
  transform-style: preserve-3d;
}

.flip-vert-enter,
.flip-vert-leave-to {
  transform: rotateX(-120deg) translateY(-16px);
  opacity: 0;
}

.flip-vert-enter-to,
.flip-vert-leave {
  transform: rotateX(0deg) translateY(0);
  opacity: 1;
}

.result-modal {
  backface-visibility: hidden;
  transform-origin: top center;
  will-change: transform, opacity;
}

/* flip-from-bottom for draw section */
.flip-vert-down-enter-active,
.flip-vert-down-leave-active {
  transition: transform 500ms cubic-bezier(0.22, 1, 0.36, 1), opacity 380ms ease;
  transform-style: preserve-3d;
}

.flip-vert-down-enter,
.flip-vert-down-leave-to {
  transform: rotateX(120deg) translateY(16px);
  opacity: 0;
}

.flip-vert-down-enter-to,
.flip-vert-down-leave {
  transform: rotateX(0deg) translateY(0);
  opacity: 1;
}
</style>
